import { makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CommentIcon from '@material-ui/icons/Comment';
import ListOfDocumentPopUp from '../listOfDocumentsPopUp';
import RemarkPopUp from '../remarksPopUp';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { CommonConfig } from '../../../config/common-config';
import PreviewImage from '../../../assets/previewImage.png';
import downloadImage from '../../../assets/downloadImage.png';
import Tooltip from '@material-ui/core/Tooltip';
import PreviewModal from '../../../components/modal/previewModal';
import { useFormik } from 'formik';
import deleteImage from '../../../assets/deleteImage.png';
import { Card, FormControl, InputLabel, CardContent, Typography, CardActions } from '@material-ui/core';
import DownGrey from '../../../assets/down_grey.png';
import Attachment from '../../../assets/Attachment.png';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
        padding: theme.spacing(2),
    },
    thead: {
        fontSize: 16,
        backgroundColor: 'gainsboro',
    },
    tableRow: {
        height: '50px',
    },
    TableHeadCss: {
        fontWeight: '700',
        fontFamily: 'Rubik',
        fontSize: '13px',
        color: '#535353',
        backgroundColor: '#f6f6f6',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '6px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
    },
    bottomLine: {
        borderTop: '1px solid #ccc !important',
        // width: '100%',
        marginBottom: '20px',
        marginLeft: '40px',
        marginRight: '40px',
    },
    inLabel: {
        fontSize: '1.5rem',
        letterSpacing: '0.09rem',
        color: '#000000',
        fontFamily: 'Rubik !important',
    },
    cardContent: {
        paddingLeft: '24px',
        bottom: '10px',
        fontFamily: ' system-ui',
        fontWeight: '500',
        fontStyle: 'initial',
        color: '#4c4c4d',
    },
    type4: {
        margin: theme.spacing(2),
        fontSize: '1.5rem',
        fontFamily: 'Rubik',
        fontWeight: '500',
    },
    cardAction: {
        marginLeft: '30px',
        // marginBottom: '15px',
        paddingBottom: '30px',
    },
    btnFieldPositionRight: {
        position: 'absolute',
        right: '15px',
        // top: '20px',
    },
    uploadBtn: {
        width: '30px',
        fontSize: '10px !important',
        height: '20px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
    border: {
        borderradius: '8px !important',
    },
    button1: {
        BorderRadius: '12px !important',
        padding: '20px',
    },
    button2: {
        margin: '0px',
    },
    downicon: {
        border: '1px solid #ababab',
        borderRadius: '6px',
        display: 'flex',
        justifyContent: 'space-between',
        lineHeight: '37px',
        padding: '0 5px 2px 10px',
        marginLeft: '14px',
        marginRight: '10px',
        marginBottom: '10px',
        '& a': {
            height: '25px',
        },
    },
    fileView: {
        width: '22px',
        height: '22px',
        position: 'relative',
        top: '6px',
        color: '#4c4c4d',
        cursor: 'pointer',
        marginRight: '6px',
        marginLeft: '12px',
    },
    fileName: {
        marginRight: '8px',
        width: '426px !important',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        overflow: 'hidden',
        marginBottom: '-6px',
    },
    scrollbarView: {
        height: '100px',
    },
    nxtLineCss: {
        '& li': {
            whiteSpace: 'pre-wrap',
        },
    },
}));

const EnhancedTableHead = (props) => {
    const { headCells, classes, action, pageName } = props;

    return (
        <TableHead size="medium" className={classes.thead}>
            <TableRow>
                {headCells.map((header) => {
                    return (
                        <TableCell key={header.id} align="left" className={classes.TableHeadCss}>
                            {header.label}
                        </TableCell>
                    );
                })}
                {action && (
                    <>
                        <TableCell align="left" className={classes.TableHeadCss}>
                            Remarks by Team
                        </TableCell>
                        <TableCell align="left" className={classes.TableHeadCss}>
                            Doc by Team
                        </TableCell>
                        <TableCell align="left" className={classes.TableHeadCss}>
                            Remarks by ITeC AM
                        </TableCell>
                        <TableCell align="left" className={classes.TableHeadCss}>
                            Doc by ITeC-others
                        </TableCell>
                    </>
                )}
                {pageName && (
                    <TableCell align="left" className={classes.TableHeadCss}>
                        Remarks
                    </TableCell>
                )}
            </TableRow>
        </TableHead>
    );
};

const DashboardTable = (props) => {
    const { headCells, AnalaysisRows, action, pageName, addRemarks, saveFile } = props;
    const [itecOpen, setItecOpen] = React.useState(false);
    const [itecViewOpen, setItecViewOpen] = React.useState(false);
    const [RemarkOpen, setRemarkOpen] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState({});
    const [handleOpenPan, setHandleOpenPan] = useState(false);
    const [clearDataPan, setClearDataPan] = useState('');
    const [isfileInvalidPan, setIsfileInvalidPan] = useState('');
    const [isDisableAttachDocBtn, setisDisableAttachDocBtn] = useState(true);
    const [selectedFileDataPan, setSelectedFileDataPan] = useState(null);
    const [filenamePan, setFilenamePan] = useState('');
    const [filename, setFilename] = useState('');
    const [uploadSuccessfullyPan, setUploadSuccessfullyPan] = useState('');
    const [isDisablePan, setIsDisablePan] = useState(true);
    const [URLValuePan, setURLValuePan] = useState();
    const [attachedFilePan, setAttachedFilePan] = useState('');
    const [URLIndex, setURLIndex] = useState('');
    const [remarks, setRemaks] = useState();
    const [remarksTitle, setRemaksTitle] = useState('');

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const classes = useStyles();
    const [visible, setVisible] = React.useState(false);
    const [downloadFile, setDownloadFile] = useState('');
    const [selectRow, setSelectRow] = useState({});
    const [dialogOpen, setDialogOpen] = React.useState(false);

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        // setShowLoaderSave(true);
        setTimeout(() => {
            // setShowLoaderSave(false);
            setVisible(true);
        }, 1000);
    };

    const handleRemoveClick = (index, row) => {
        //console.log('Before', index, row)
        // const list = [...selectRow];
        // list.splice(index, 1);
        // setSelectRow(list);
        if (AnalaysisRows && AnalaysisRows.length) {
            AnalaysisRows.map((ele, i) => {
                if (ele.questionId === selectRow.questionId) {
                    row.attachmentsByItecteam.splice(index, 1);
                    setItecViewOpen(false);
                    return setSelectRow(row);
                    //   ele.attachmentsByItecteam.splice(index, 1);
                }
            });
        }
        //console.log('props.data.attachmentsByCoreteam', index, row, AnalaysisRows)
    };

    const DataRow = (analysisRow) => {
        return headCells.map((header) => {
            let tableData;
            //console.log(header, 'headerRow');
            //console.log(analysisRow, 'Row Data');
            tableData = (
                <TableCell align="left" key={header.id}>
                    {analysisRow[header.id]}
                </TableCell>
            );
            return tableData;
        });
    };

    const handleRelevence = (row) => {
        setSelectedRow(row);
        setItecOpen(true);
    };
    const handleItecClose = () => {
        setItecOpen(false);
    };

    const handleRemark = (row) => {
        setSelectedRow(row);
        setRemarkOpen(true);
    };
    const handleRemarkClose = () => {
        setRemarkOpen(false);
    };
    const handleClosePan = () => {
        setHandleOpenPan(false);
        setIsfileInvalidPan('');
        setUploadSuccessfullyPan('');
    };
    const handleClickPan = (index) => {
        setURLIndex(index);
        setHandleOpenPan(true);
        setFilenamePan('');
        setFilename('');
        setClearDataPan('');
        setIsDisablePan(true);
    };
    const fileUploadPan = (files) => {
        saveFile(AnalaysisRows[URLIndex].questionId, files);
        setUploadSuccessfullyPan('Uploaded a file successfully');
        setTimeout(() => {
            handleClosePan();
        }, 500);
    };
    const isFileUploadPan = (event, selectorFiles) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(xlsx|xls|csv|png|jpeg|jpg|pdf|zip)$');
            setFilenamePan(selectorFiles);
            setFilename(selectorFiles[0].name);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalidPan('');
                setIsDisablePan(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalidPan('Please select the file size less than 10MB');
                    setIsDisablePan(true);
                } else {
                    setSelectedFileDataPan(selectorFiles[0]);
                }
            } else {
                setIsfileInvalidPan('Please select valid file formate i.e xlsx/xls/csv');
                setIsDisablePan(true);
            }
        }
    };

    const handleRows = (row) => {
        setSelectRow(row);
        setItecViewOpen(true);
    };

    const handleOpenDialog = (row, val) => {
        if (val === 'EM') {
            setRemaksTitle('Remarks by Team');
            // AnalaysisRows.filter((ele) => {
            setRemaks(row.remarkByCoreteam);
            // })
        } else if (val === 'itec') {
            setRemaksTitle('Remarks by ITeC others');
            // AnalaysisRows.filter((ele) => {
            setRemaks(row.remarkByItecteam);
            // })
        } else if (val === 'AM') {
            setRemaksTitle('Remarks by ITeC AM');
            // AnalaysisRows.filter((ele) => {
            setRemaks(row.remarkByItecAM);
            // })
        }
        setTimeout(() => {
            setDialogOpen(true);
        }, 200);
    };

    return (
        <>
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <TableContainer>
                        <Table className={classes.table}>
                            <EnhancedTableHead classes={classes} headCells={headCells} action={action} pageName={pageName} />
                            <TableBody>
                                {AnalaysisRows &&
                                    AnalaysisRows.map((rows, index) => {
                                        const rowData = DataRow(rows);
                                        return (
                                            <TableRow hover key={index} className={classes.tableRow}>
                                                {rowData}
                                                {action && (
                                                    <>
                                                        <TableCell align="left">
                                                            {rows && rows.remarkByCoreteam && rows.remarkByCoreteam.length ? (
                                                                <CommentIcon onClick={() => handleOpenDialog(rows, 'EM')} />
                                                            ) : (
                                                                <span style={{ marginLeft: '8px' }}>-</span>
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {rows && rows.attachmentsByCoreteam && rows.attachmentsByCoreteam.length ? (
                                                                <img
                                                                    src={Attachment}
                                                                    alt="attachment"
                                                                    onClick={() => handleRelevence(rows)}
                                                                />
                                                            ) : (
                                                                <span style={{ marginLeft: '8px' }}>-</span>
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {rows && rows.remarkByItecAM && rows.remarkByItecAM.length ? (
                                                                <CommentIcon onClick={() => handleOpenDialog(rows, 'AM')} />
                                                            ) : (
                                                                <span style={{ marginLeft: '8px' }}>-</span>
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <Button
                                                                variant="outlined"
                                                                component="label"
                                                                color="primary"
                                                                className="txt-capitalize"
                                                                onClick={() => handleClickPan(index)}
                                                            >
                                                                Upload
                                                                <span style={{ color: '#ff0a047a' }}>*</span>
                                                            </Button>
                                                            {rows && rows.attachmentsByItecteam && rows.attachmentsByItecteam.length ? (
                                                                <Tooltip title="Preview">
                                                                    <img
                                                                        src={PreviewImage}
                                                                        alt="PreviewImage"
                                                                        className={classes.fileView}
                                                                        onClick={() => handleRows(rows)}
                                                                    />
                                                                </Tooltip>
                                                            ) : null}
                                                            <Dialog
                                                                open={itecViewOpen}
                                                                onClose={() => setItecViewOpen(false)}
                                                                maxWidth="sm"
                                                                fullWidth
                                                                aria-labelledby="customized-dialog-title"
                                                            >
                                                                <Card>
                                                                    <CardContent className={classes.cardContent}>
                                                                        <Typography variant="h4" className={classes.type4}>
                                                                            {' '}
                                                                            List of Documents
                                                                        </Typography>
                                                                    </CardContent>
                                                                    <DialogContent>
                                                                        {selectRow && selectRow.attachmentsByItecteam ? (
                                                                            <span>
                                                                                {selectRow &&
                                                                                    selectRow.attachmentsByItecteam.map((path, i) => {
                                                                                        return (
                                                                                            <div
                                                                                                key={i.toString()}
                                                                                                className={classes.downicon}
                                                                                            >
                                                                                                <div className={classes.fileName}>
                                                                                                    {path.substring(
                                                                                                        path.lastIndexOf('/') + 1
                                                                                                    )}
                                                                                                </div>
                                                                                                <div>
                                                                                                    <span
                                                                                                        onClick={() =>
                                                                                                            handlePreviewModal(path)
                                                                                                        }
                                                                                                    >
                                                                                                        <Tooltip title="Preview">
                                                                                                            <img
                                                                                                                src={PreviewImage}
                                                                                                                alt="PreviewImage"
                                                                                                                className="fileView"
                                                                                                                style={{
                                                                                                                    top: '7px',
                                                                                                                    left: '8px',
                                                                                                                }}
                                                                                                            />
                                                                                                        </Tooltip>
                                                                                                    </span>
                                                                                                    <a
                                                                                                        // href={path}
                                                                                                        style={{
                                                                                                            textDecoration: 'none',
                                                                                                            margin: '5px',
                                                                                                        }}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        // download
                                                                                                        // onClick={() => handleDownload(path)}
                                                                                                    >
                                                                                                        <Tooltip title="Delete">
                                                                                                            <img
                                                                                                                src={deleteImage}
                                                                                                                alt="deleteImage"
                                                                                                                className="closeImg"
                                                                                                                style={{
                                                                                                                    top: '9px',
                                                                                                                    left: '4px',
                                                                                                                }}
                                                                                                                onClick={() =>
                                                                                                                    handleRemoveClick(
                                                                                                                        i,
                                                                                                                        selectRow
                                                                                                                    )
                                                                                                                }
                                                                                                            />
                                                                                                        </Tooltip>
                                                                                                    </a>
                                                                                                </div>
                                                                                                <PreviewModal
                                                                                                    fileSource={downloadFile}
                                                                                                    visibleClose={visible}
                                                                                                    handleModalClose={handleModalClose}
                                                                                                />
                                                                                            </div>
                                                                                        );
                                                                                    })}
                                                                            </span>
                                                                        ) : null}
                                                                    </DialogContent>
                                                                </Card>
                                                                <CardActions className={classes.cardAction}>
                                                                    <div>
                                                                        <Button
                                                                            variant="contained"
                                                                            color="primary"
                                                                            className="txt-capitalize"
                                                                            onClick={() => setItecViewOpen(false)}
                                                                        >
                                                                            {' '}
                                                                            Close
                                                                        </Button>
                                                                    </div>
                                                                </CardActions>
                                                            </Dialog>

                                                            <Dialog
                                                                onClose={handleClosePan}
                                                                PaperProps={{
                                                                    className: 'QandADailogBox',
                                                                    style: { padding: '20px' },
                                                                }}
                                                                aria-labelledby="form-dialog-title"
                                                                open={handleOpenPan}
                                                                clear={clearDataPan}
                                                            >
                                                                <DialogTitle id="form-dialog-title">
                                                                    Upload File
                                                                    {/* <IconButton
                                                    aria-label="close"
                                                    className={classes.closeButton}
                                                    onClick={handleClosePan}
                                                >
                                                    <CloseIcon />
                                                </IconButton> */}
                                                                </DialogTitle>
                                                                <DialogContent style={{ textAlign: 'center' }}>
                                                                    <Button
                                                                        className="btnOrange"
                                                                        variant="outlined"
                                                                        component="label"
                                                                        color="default"
                                                                    >
                                                                        <i className="btnIcon">
                                                                            <FontAwesomeIcon icon={faPlus} />
                                                                        </i>{' '}
                                                                        Add File
                                                                        <input
                                                                            type="file"
                                                                            hidden
                                                                            multiple
                                                                            name="images"
                                                                            onChange={(e) => isFileUploadPan(e, e.target.files)}
                                                                            accept=".jpeg,.png,.csv,.zip,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,image/*"
                                                                            // onChange={(event) => saveFile(rows.questionId, event)}
                                                                        />
                                                                    </Button>
                                                                    {filename ? (
                                                                        <p className="fileName">
                                                                            {filename.substring(0, 15)}
                                                                            {filename.length > 15 ? '...' : ''}
                                                                        </p>
                                                                    ) : null}
                                                                    {/* <p className="fileName">{filename}</p> */}

                                                                    {filename ? (
                                                                        isfileInvalidPan && isfileInvalidPan.length > 0 ? (
                                                                            <p className="noteCss">Note: {isfileInvalidPan}</p>
                                                                        ) : (
                                                                            ''
                                                                        )
                                                                    ) : null}
                                                                </DialogContent>
                                                                <p className="fileNameGreen">{uploadSuccessfullyPan}</p>
                                                                <DialogActions className="paddingBtm txtCenter">
                                                                    <Button
                                                                        className={isDisablePan ? classes.disableBtn : 'btnBluepop'}
                                                                        onClick={(e) => fileUploadPan(filenamePan)}
                                                                        variant="contained"
                                                                        disabled={isDisablePan}
                                                                        component="label"
                                                                        color="default"
                                                                    >
                                                                        Upload
                                                                    </Button>
                                                                    <Button
                                                                        className="btnBluepop"
                                                                        onClick={handleClosePan}
                                                                        variant="contained"
                                                                        component="label"
                                                                        color="default"
                                                                    >
                                                                        Cancel
                                                                    </Button>
                                                                </DialogActions>
                                                            </Dialog>
                                                        </TableCell>
                                                    </>
                                                )}
                                                {pageName && (
                                                    <TableCell>
                                                        <CommentIcon onClick={() => handleRemark(rows)} style={{ float: 'left' }} />
                                                        <span style={{ color: '#ff0a047a' }}>*</span>
                                                    </TableCell>
                                                )}
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
                <Dialog
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)}
                    maxWidth="sm"
                    fullWidth
                    aria-labelledby="customized-dialog-title"
                >
                    <Card>
                        <CardContent className={classes.cardContent}>
                            <Typography variant="h4" className={classes.type4}>
                                {remarksTitle}
                            </Typography>
                        </CardContent>
                        <DialogContent className={classes.scrollbarView}>
                            <div>
                                {remarks &&
                                    remarks.map((ele) => {
                                        return (
                                            <ul
                                                className={classes.nxtLineCss}
                                                style={{ margin: '0px', paddingLeft: '31px', paddingBottom: '12px' }}
                                            >
                                                <li>{ele}</li>
                                            </ul>
                                        );
                                    })}
                            </div>
                        </DialogContent>
                    </Card>
                    <CardActions className={classes.cardAction}>
                        <div>
                            <Button variant="contained" color="primary" className="txt-capitalize" onClick={() => setDialogOpen(false)}>
                                {' '}
                                Close
                            </Button>
                        </div>
                    </CardActions>
                </Dialog>
            </div>
            {itecOpen && <ListOfDocumentPopUp itecOpen={itecOpen} handleItecClose={handleItecClose} selectedRow={selectedRow} />}
            {RemarkOpen && (
                <RemarkPopUp
                    RemarkOpen={RemarkOpen}
                    handleRemarkClose={handleRemarkClose}
                    selectedRow={selectedRow}
                    addRemarks={addRemarks}
                    AnalaysisRows={AnalaysisRows}
                />
            )}
        </>
    );
};

export default DashboardTable;
